// @flow
import { createReducer, createActions } from 'reduxsauce'
import Immutable from 'seamless-immutable'

/* ------------- Types and Action Creators ------------- */

const { Types, Creators } = createActions({
  getColourRequest: ['data'],
  getColourSuccess: ['data'],
  getColourFailure: ['err'],

  getAllColourRequest: ['data'],
  getAllColourSuccess: ['data'],
  getAllColourFailure: ['err'],

  createColourRequest: ['data'],
  createColourSuccess: ['data'],
  createColourFailure: ['err'],

  updateColourRequest: ['data'],
  updateColourSuccess: ['data'],
  updateColourFailure: ['err'],

  deleteColourRequest: ['data'],
  deleteColourSuccess: ['data'],
  deleteColourFailure: ['err']

})

export const ColourTypes = Types
export default Creators

/* ------------- Initial State ------------- */

export const INITIAL_STATE = Immutable({
  fetching: false,
  data: [],
  dataAll: [],
  err: null,
  processing: false,
  success: null
})

/* ------------- Reducers ------------- */
// we're attempting to login
export const request = (state: Object) =>
  state.merge({ fetching: true, err: null })

// we've successfully logged in
export const success = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    data,
    err: null,
    success: null
  })

export const successAll = (state: Object, { data }: Object) =>
  state.merge({
    fetching: false,
    dataAll: data,
    err: null,
    success: null
  })

// we've had a problem logging in
export const failure = (state: Object, { err }: Object) =>
  state.merge({ fetching: false, err })

export const manipulateRequest = (state: Object) => state.merge({ processing: true, success: null })
export const manipulateSuccess = (state: Object, { data }: Object) =>
  state.merge({
    processing: false,
    success: true,
    err: null
  })
export const manipulateFailure = (state: Object, { err }: Object) =>
state.merge({ processing: false, err, success: null })

/* ------------- Hookup Reducers To Types ------------- */
export const reducer = createReducer(INITIAL_STATE, {
  [Types.GET_COLOUR_SUCCESS]: success,
  [Types.GET_COLOUR_REQUEST]: request,
  [Types.GET_COLOUR_FAILURE]: failure,

  [Types.GET_ALL_COLOUR_SUCCESS]: successAll,
  [Types.GET_ALL_COLOUR_REQUEST]: request,
  [Types.GET_ALL_COLOUR_FAILURE]: failure,

  [Types.CREATE_COLOUR_SUCCESS]: success,
  [Types.CREATE_COLOUR_REQUEST]: request,
  [Types.CREATE_COLOUR_FAILURE]: failure,

  [Types.UPDATE_COLOUR_SUCCESS]: manipulateSuccess,
  [Types.UPDATE_COLOUR_REQUEST]: manipulateRequest,
  [Types.UPDATE_COLOUR_FAILURE]: manipulateFailure,

  [Types.DELETE_COLOUR_SUCCESS]: manipulateSuccess,
  [Types.DELETE_COLOUR_REQUEST]: manipulateRequest,
  [Types.DELETE_COLOUR_FAILURE]: manipulateFailure
})



// WEBPACK FOOTER //
// ./src/Redux/ColourRedux.js